import SocketFactory from '@/drivers/socket'

import type { PrinterConfig, PrinterDriver } from '../types'
import { ZPLEncoder } from './zpl-encoder'

export default class ZPL implements PrinterDriver {
  private config: PrinterConfig

  constructor(config: PrinterConfig) {
    this.config = config
  }

  printImage(canvas: HTMLCanvasElement) {
    return new Promise<void>((resolve, reject) => {
      const socket = SocketFactory.getSocket()
      socket.open(
        this.config.ip,
        9100,
        async () => {
          const width = this.config.ticketWidth || 380
          const height = this.config.ticketHeight || 350
          const paddingLeft = this.config.ticketPaddingLeft || 220

          const encoder = new ZPLEncoder()
          const result = encoder.image(canvas, { width, height, paddingLeft }).encode()
          socket.write(
            result,
            () => {
              socket.shutdownWrite(() => {
                resolve()
              }, reject)
            },
            reject
          )
        },
        reject
      )
    })
  }

  openCashDrawer() {
    // Not supported in ZPL
  }
}
